import './Search.scss';

import React from 'react';

import Icon from 'components/Icon';
import Input from 'components/Input';

export default class Search extends React.Component {
    static propTypes = {
        handleSearchTermChange: React.PropTypes.func.isRequired,
        handleSearch: React.PropTypes.func.isRequired,
        placeholder: React.PropTypes.string,
        value: React.PropTypes.string.isRequired
    };

    constructor() {
        super();

        // This will be set to true when search query reaches 3 characters in length
        // This will be set to false when search query is zeroed out
        // If false, will not perform search on new character.
        this.activeSearch = false;
        this.searchDebounceTimer = null;
    }

    /**
     * @desc    Perform a search based on user input.
     *          This will set this.activeSearch and perform search if debounced
     * @param   event
     */
    _handleSearchTermChange(event) {
        let searchValue = event.target.value;
        this.props.handleSearchTermChange(searchValue);
        if(this.activeSearch === false && searchValue.length >= 3) {
            this.activeSearch = true;
        }

        if(this.activeSearch === true) {
            if(searchValue.length > 0) {
                window.clearTimeout(this.searchDebounceTimer);
                this.searchDebounceTimer = setTimeout(() => {
                    this.props.handleSearch(searchValue);
                }, 150)
            } else {
                window.clearTimeout(this.searchDebounceTimer);
                this.activeSearch = false;
                this.searchDebounceTimer = setTimeout(() => {
                    this.props.handleSearch(searchValue);
                }, 150)
            }
        }
    }

    render() {
        return (
            <div className="search--wrapper">
                <Input type="search"
                       id="txtSearch"
                       onChange={this._handleSearchTermChange.bind(this)}
                       value={this.props.value}
                       placeholder={this.props.placeholder} />
                <label htmlFor="txtSearch">
                    <Icon icon="search" />
                </label>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Search/index.js